import React from 'react';
import { Mail, Phone, MapPin, Facebook, Instagram, Linkedin, Twitter, MessageCircle } from 'lucide-react';
import { Link } from 'react-router-dom';
import { useApp } from '../context/AppContext';

const Footer = () => {
  const { t, lang } = useApp();
  const pricesLabel = (t('nav.prices') !== 'nav.prices' ? t('nav.prices') : { de: 'Preise', en: 'Prices', fr: 'Prix', it: 'Prezzi' }[lang]) || 'Prices';
  const cols = [
    { title: t('footer.company'), links: [
      { label: 'About Us', to: '/about' }, { label: 'Our Fleet', to: '/fleet' }, { label: pricesLabel, to: '/prices' }, { label: 'Airport Transfers', to: '/transfers' }, { label: 'Careers', to: '/careers' }, { label: 'Blog', to: '/blog' },
    ] },
    { title: t('footer.support'), links: [
      { label: 'Help Center', to: '/help' }, { label: 'Contact Us', to: '/contact' }, { label: 'FAQ', to: '/faq' }, { label: 'Manage Booking', to: '/booking' }, { label: 'Track Driver', to: '/driver' },
    ] },
    { title: t('footer.legal'), links: [
      { label: 'Terms & Conditions', to: '/terms' }, { label: 'Privacy Policy', to: '/privacy' }, { label: 'Cookie Policy', to: '/cookies' }, { label: 'Refund Policy', to: '/refund' },
    ] },
  ];
  return (
    <footer id="business" className="bg-[color:var(--brand-dark)] text-white pt-16 pb-8">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <div className="grid lg:grid-cols-5 gap-10">
          <div className="lg:col-span-2">
            <div className="flex items-center gap-2 mb-5">
              <span data-no-translate className="font-extrabold text-2xl tracking-tight text-white">CAB<span style={{ color: 'var(--brand-accent)' }}>.TAXI</span></span>
            </div>
            <p className="text-sm text-white/60 leading-relaxed max-w-sm">{t('footer.about')}</p>
            <div className="mt-6 space-y-2 text-sm text-white/70">
              <a href="mailto:Info@cab.taxi" className="flex items-center gap-2 hover:text-[color:var(--brand-accent)] transition-colors"><Mail className="w-4 h-4" /> Info@cab.taxi</a>
              <a href="tel:+41791772424" className="flex items-center gap-2 hover:text-[color:var(--brand-accent)] transition-colors"><Phone className="w-4 h-4" /> +41 79 177 24 24</a>
              <a href="https://wa.me/41791772424" target="_blank" rel="noopener noreferrer" className="flex items-center gap-2 hover:text-[color:var(--brand-accent)] transition-colors"><MessageCircle className="w-4 h-4" /> WhatsApp: +41 79 177 24 24</a>
              <div className="flex items-start gap-2"><MapPin className="w-4 h-4 mt-0.5" /> Blumenfeldstrasse 1, 8046 Zürich</div>
            </div>
            <div className="mt-6 flex gap-3">
              {[Facebook, Instagram, Linkedin, Twitter].map((Icon, i) => (
                <a key={i} href="#social" className="w-9 h-9 rounded-full bg-white/10 flex items-center justify-center hover:bg-[color:var(--brand-accent)] hover:text-white transition-colors"><Icon className="w-4 h-4" /></a>
              ))}
            </div>
          </div>
          {cols.map((c) => (
            <div key={c.title}>
              <h4 className="font-bold mb-4">{c.title}</h4>
              <ul className="space-y-2.5">
                {c.links.map((l) => (
                  <li key={l.label}>
                    {l.to
                      ? <Link to={l.to} className="text-sm text-white/60 hover:text-[color:var(--brand-accent)] transition-colors" data-testid={`footer-link-${String(l.label || '').toLowerCase().replace(/\s+/g, '-')}`}>{l.label}</Link>
                      : <a href="#link" className="text-sm text-white/60 hover:text-[color:var(--brand-accent)] transition-colors">{l.label}</a>}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
        <div className="mt-12 pt-6 border-t border-white/10 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-white/50">© {new Date().getFullYear()} CAB.TAXI. {t('footer.rights')}</p>
          <p className="text-xs text-white/40">Made with care in Zurich 🇭🇨</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
